module.exports = __webpack_public_path__ + "img/2_2_3__1.e857c67a.png";